import MatchEvent from 'interfaces/matchEvent';
import { MatchEventType } from '../enums/matchEventType';

// finds the first instance of a matchEvent of a certain type
export default function (matchEvents: MatchEvent[], matchEventTypeId: MatchEventType): MatchEvent | undefined {
  return matchEvents.find((matchEvent) => matchEvent.matchEventTypeId === matchEventTypeId);
}
